import { useCallback } from "react";
import { createContext, useContext, useState } from "react";
import { defaultData } from "../hardcoded";
import DataStoreService from '../../../services/DataStore';
import ChannelsService from "../../../services/ChannelsService";
import { useSelector } from "react-redux";

export const useStoreContext = () => {
  const [data, setData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const { user } = useSelector((state) => state.authentication);

  const fetchForm = useCallback(async (returnForm = false) => {
    try {
      if (formLoaded) {
        if (returnForm) {
          return data.form;
        }

        return;
      }

      setFormLoading(true);
      const { data: _dataFormLocation } = await DataStoreService.getForm('location');
      const { data: _dataFormStakeholder } = await DataStoreService.getForm('stakeholder');
      const { data: _dataFormEvent } = await DataStoreService.getForm('event');
      const form = {
        locations: _dataFormLocation.store,
        entities: _dataFormStakeholder.store,
        events: _dataFormEvent.store,
      };
      setFormLoading(false);

      if (returnForm) {
        return form;
      }

      setData((prev) => ({ ...prev, form }));
      setFormLoaded(true);
    } catch (err) {
      console.log(err)
    }

    setFormLoading(false);
  }, [formLoaded, data]);

  const fetchStore = useCallback(async (checkFetched = true) => {
    if (fetched && checkFetched) {
      return;
    }

    setLoading(true);

    try {
      const { data: _data } = await DataStoreService.getTifDashboard();
      const { data: _channelsData } = await ChannelsService.getChannels({
        inbound: user?.company?.id,
        outbound: user?.company?.id,
      });
      const _dataForm = await fetchForm(true);

      setFormLoaded(true);

      setData({
        ..._data,
        channel: _channelsData,
        form: _dataForm,
      });
      setFetched(true);
    } catch (err) {
      setData(defaultData);
      setFetched(true);
    }

    setLoading(false);
  }, [fetched, fetchForm, user]);

  return {
    data,
    loading,
    fetchForm,
    setLoading,
    setFetched,
    fetchStore,
    formLoading,
  };
}

export const StoreContext = createContext({
  data: defaultData,
  loading: false,
  formLoading: false,
  setFetched: () => { },
  fetchForm: () => { },
  fetchStore: () => { },
  setLoading: () => { },
});

export const StoreProvider = ({ children }) => {
  const value = useStoreContext();

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
}

export default function useStore() {
  const value = useContext(StoreContext);
  return value;
}
